import React from "react";
import {LazyLoadComponent, LazyLoadComponentProps} from "react-lazy-load-image-component";

import {isCI} from "../../utils/env";

export const LazyComp: React.FC<LazyLoadComponentProps> = ({visibleByDefault, ...props}) => (
  <LazyLoadComponent {...props} visibleByDefault={!!isCI || visibleByDefault} />
);
